import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["nav", "group", "mobileToggle"];
  static values = { mobileOpen: { type: Boolean, default: false } };

  toggleGroup(event) {
    const group = event.target.closest('[data-admin-nav-target="group"]');
    if (!group) return;
    const expanding = group.dataset.expanded !== "true";

    this.groupTargets.forEach((g) => {
      const expanded = g === group && expanding ? "true" : "false";
      g.dataset.expanded = expanded;
      const header = g.querySelector(".admin-nav__group-header");
      if (header) header.setAttribute("aria-expanded", expanded);
    });
  }

  toggleMobile() {
    this.mobileOpenValue = !this.mobileOpenValue;
  }

  mobileOpenValueChanged() {
    if (this.hasNavTarget) {
      this.navTarget.classList.toggle(
        "admin-nav__mobile-open",
        this.mobileOpenValue,
      );
    }
    if (this.hasMobileToggleTarget) {
      this.mobileToggleTarget.setAttribute(
        "aria-expanded",
        this.mobileOpenValue,
      );
    }
  }

  navigate() {
    this.mobileOpenValue = false;
  }

  closeMobile(event) {
    if (!this.element.contains(event.target)) {
      this.mobileOpenValue = false;
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.mobileOpenValue) {
      this.mobileOpenValue = false;
    }
  }
}
